import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <footer class="footer">
        <div class="container">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-4">
            <p class="heading  small align-right">
              درباره هشتگ بیمه
            </p>
            <p style="text-align: justify">
                   بیمه سامان یک دستیار شخصی بیمه می باشد که می خواهد شما را در یافتن و خرید بهترین خدمات بیمه ای یاری نماید.
             </p>
          </div>
          <div class="col-6 col-sm-6 col-md-4">
            <p class="heading  small align-right"> اطلاعات بیشتر</p>
            <p><a routerLink="/about-us">درباره ما</a></p>
            <p><a routerLink="/terms">شرایط و قوانین</a></p>
            <p><a href="https://www.centinsur.ir/">بیمه مرکزی</a></p>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <p class="heading  small align-right">راه‌های ارتباطی با ما</p>
            <!-- <p> آدرس: تهران، کوی نصر (گیشا)، کوچه شهابی (۲۸)، پلاک ۷</p> -->
            <p> پست الکترونیکی: <span class="numeric"> info@samaninsurance.com </span></p>
            <!-- <p> تلفن پشتیبانی: <span class="numeric"> ۰۲۱-۸۶۱۱۲۸۳۵ </span></p> -->
            <!--social-media-->
            <div class="social-media">
              <a href="https://www.instagram.com/samaninsurance"><i class="fa fa-instagram"></i></a>
              <a href="https://www.twitter.com/samaninsurance/"><i class="fa fa-twitter-square"></i></a>
              <a href="https://www.facebook.com/samaninsurance"><i class="fa fa-facebook-square"></i></a>
              <a href="https://t.me/samaninsurance"><i class="fa fa-telegram"></i></a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <small>کلیه حقوق این سایت متعلق به وب سایت
              <a class="mx-1" href="http://www.samaninsurance.com/" class="link_white" lang="fa-ir"></a>© 2019,<a class="mx-0" href="https://www.samaninsurance.com/" class="link_white">samaninsurance.com</a>
            </small>
          </div>
        </div>
      </div>
    </footer>
  `,
  styleUrls: [
    '../assets/css/navbar.css'
  ]
})
export class AppFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
